import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { xl: "9", lg: "9", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VForm,
                {
                  ref: "form",
                  staticClass: "mb-0",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.validform,
                    callback: function ($$v) {
                      _vm.validform = $$v
                    },
                    expression: "validform",
                  },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.organization")
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticStyle: { padding: "0px" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.organizations,
                                      dense: "",
                                      outlined: "",
                                      value: _vm.item.organization,
                                      disabled: _vm.readonly,
                                      rules: _vm.requiredFlag
                                        ? [
                                            function (v) {
                                              return (
                                                _vm.organizations.includes(v) ||
                                                _vm.$t(
                                                  "my_tasks.modals.required"
                                                )
                                              )
                                            },
                                            function (v) {
                                              return (
                                                !!v ||
                                                _vm.$t(
                                                  "my_tasks.modals.required"
                                                )
                                              )
                                            },
                                          ]
                                        : [],
                                    },
                                    model: {
                                      value: _vm.item.organization,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item, "organization", $$v)
                                      },
                                      expression: "item.organization",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.operator")
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      disabled: _vm.readonly,
                                      dense: "",
                                      outlined: "",
                                      rules: [
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("my_tasks.modals.required")
                                          )
                                        },
                                        function (v) {
                                          return (
                                            /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                              v
                                            ) ||
                                            _vm.$t(
                                              "my_tasks.modals.email_invalid"
                                            )
                                          )
                                        },
                                      ],
                                    },
                                    model: {
                                      value: _vm.item.data_operator,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item, "data_operator", $$v)
                                      },
                                      expression: "item.data_operator",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.domain")
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticStyle: { padding: "0px" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.readonly,
                                      items: _vm.selectDomain,
                                      rules: _vm.requiredFlag
                                        ? [
                                            function (v) {
                                              return (
                                                !!v ||
                                                _vm.$t(
                                                  "my_tasks.modals.required"
                                                )
                                              )
                                            },
                                          ]
                                        : [],
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.item.ksubdomain = ""
                                      },
                                    },
                                    model: {
                                      value: _vm.item.kdomain,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item, "kdomain", $$v)
                                      },
                                      expression: "item.kdomain",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.subdomain")
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.readonly,
                                      items: _vm.filterSubDomain,
                                      rules: _vm.requiredFlag
                                        ? [
                                            function (v) {
                                              return (
                                                !!v ||
                                                _vm.$t(
                                                  "my_tasks.modals.required"
                                                )
                                              )
                                            },
                                          ]
                                        : [],
                                    },
                                    model: {
                                      value: _vm.item.ksubdomain,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item, "ksubdomain", $$v)
                                      },
                                      expression: "item.ksubdomain",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.environment")
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items:
                                        _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                          .enumValues,
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.readonly,
                                    },
                                    model: {
                                      value: _vm.item.environment,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item, "environment", $$v)
                                      },
                                      expression: "item.environment",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.sensitive")
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticStyle: { padding: "0px" } },
                                [
                                  _c(VCheckbox, {
                                    attrs: { disabled: _vm.readonly },
                                    model: {
                                      value: _vm.item.sensitive_data,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item,
                                          "sensitive_data",
                                          $$v
                                        )
                                      },
                                      expression: "item.sensitive_data",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { xl: "3", lg: "3", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VRow,
                [
                  _vm.showButtonAttachment
                    ? _c(
                        VCol,
                        [
                          !_vm.readonly
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    disabled: _vm.readonly,
                                    outlined: "",
                                    rounded: "",
                                    small: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$refs.fileInput.$el
                                        .querySelector("input[type=file]")
                                        .click()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("my_tasks.modals.attach"))
                                  ),
                                  _c(VIcon, [_vm._v("mdi-paperclip")]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCol,
                    [
                      _c("b-form-file", {
                        ref: "fileInput",
                        staticStyle: { display: "none" },
                        attrs: { accept: _vm.METADATA_FILE_FORMAT.join(",") },
                        on: { change: _vm.onFileChange },
                        model: {
                          value: _vm.inputUploadFile,
                          callback: function ($$v) {
                            _vm.inputUploadFile = $$v
                          },
                          expression: "inputUploadFile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.files.length,
                          expression: "files.length",
                        },
                      ],
                    },
                    [
                      _c(VSimpleTable, [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "text-align": "left",
                                  "vertical-align": "middle",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("my_tasks.modals.files")))]
                            ),
                            _c("th", {
                              staticStyle: {
                                "text-align": "center",
                                "vertical-align": "middle",
                              },
                            }),
                            _c("th", {
                              staticStyle: {
                                "text-align": "center",
                                "vertical-align": "middle",
                              },
                            }),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.files, function (file, index) {
                            return _c("tr", { key: index }, [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "text-align": "left",
                                    "vertical-align": "middle",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      file.fileName.substring(
                                        file.fileName.length - 23,
                                        file.fileName.length
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "vertical-align": "middle",
                                  },
                                },
                                [
                                  _vm.METADATA_IMAGE_FORMAT.filter(function (
                                    format
                                  ) {
                                    return file.fileName
                                      .toLowerCase()
                                      .endsWith(format)
                                  }).length
                                    ? _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            outlined: "",
                                            color: "primary",
                                            dense: "",
                                            disabled: _vm.readonly,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClickLink(file)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-image")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        VBtn,
                                        {
                                          attrs: { color: "#515154" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openImage(
                                                file.fileLink
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-download")]
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                              !_vm.readonly
                                ? _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "vertical-align": "middle",
                                      },
                                    },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteFile(file)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-delete")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VSubheader, { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("my_tasks.modals.description"))),
              ]),
              _c(VTextarea, {
                attrs: {
                  outlined: "",
                  disabled: _vm.readonly,
                  "no-resize": "",
                  rows: "3",
                  rules: _vm.requiredFlag
                    ? [
                        function (v) {
                          return !!v || _vm.$t("my_tasks.modals.required")
                        },
                      ]
                    : [],
                },
                model: {
                  value: _vm.item.object_description,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "object_description", $$v)
                  },
                  expression: "item.object_description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "preview-file",
          attrs: {
            id: "preview-file",
            "hide-footer": "",
            "no-close-on-backdrop": true,
            "no-close-on-esc": true,
          },
        },
        [
          _c(
            "b-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.currentFile.fileLink &&
                    _vm.METADATA_IMAGE_FORMAT.filter(function (file) {
                      return _vm.currentFile.fileName
                        .toLowerCase()
                        .endsWith(file)
                    }).length,
                  expression:
                    "currentFile.fileLink && METADATA_IMAGE_FORMAT.filter(file => currentFile.fileName.toLowerCase().endsWith(file)).length",
                },
              ],
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.currentFile.fileLink,
                    download: _vm.currentFile.fileName,
                    target: "_blank",
                  },
                },
                [
                  _c("b-img", {
                    attrs: {
                      src: _vm.currentFile.fileLink,
                      fluid: "",
                      alt: _vm.currentFile.fileName,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }